import React from "react";
import { IconMap2 } from "@tabler/icons-react";
import { HeatMapFeaturedPolygon } from "../../models/heatMapModel";
import isEmpty from "lodash/isEmpty";

const SHADES = ["bg-[#00854E]/70", "bg-[#00854E]/80", "bg-[#00854E]/90"];

const MOCK_ZONES: HeatMapFeaturedPolygon[] = [
  { id: 1, name: "Belisario Porras", level: 1, ppm2: "$3,400/m²" },
  { id: 2, name: "Omar Torrijos", level: 1, ppm2: "$3,400/m²" },
  { id: 3, name: "Belisario Frías", level: 1, ppm2: "$3,400/m²" },
];

interface Props {
  zones?: HeatMapFeaturedPolygon[];
  onSelect?: (zone: Pick<HeatMapFeaturedPolygon, "id" | "name">) => void;
}

const FeaturedZones: React.FC<Props> = ({ zones, onSelect }) => {
  const list = zones ?? MOCK_ZONES;
  if (isEmpty(list)) return null;
  return (
    <div className="flex flex-col gap-2 bg-white p-2 rounded-xl">
      <p className="text-md font-bold leading-none text-gray-900">Zonas Destacadas</p>
      {list.map((zone, i) => (
        <div key={zone.id} className="flex items-center gap-3 bg-gray-200 rounded-xl p-3 cursor-pointer" onClick={() => onSelect?.(zone)}>
          <div className={`w-10 h-10 rounded-lg ${SHADES[i % SHADES.length]} flex items-center justify-center shrink-0`}>
            <IconMap2 size={18} className="text-white" />
          </div>
          <div className="flex-1">
            <p className="text-sm font-medium text-gray-900 leading-none">{zone.name}</p>
            <p className="text-xs text-gray-500 mt-1">{zone.ppm2}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default FeaturedZones;
